<template>
  <div>
    <cricket-match-innings-menu
      :match="match"
      :matchUserPref="matchUserPref"
    ></cricket-match-innings-menu>

    <div
      v-for="(teamInn, i) in match.batting_order"
      v-if="i == matchUserPref.activeInnings"
      :key="i">
      <cricket-match-scorecard-partnership
        class="space-15"
        :match="match"
        :inningsNumber="teamInn[1]"
        :teamI="teamInn[0]"
        @playerSelected="onPlayerSelected"
        @ballSelected="onBallSelected"></cricket-match-scorecard-partnership>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    match: Object,
    matchUserPref: Object
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
